export default __webpack_public_path__ + "a66054f2fbd6bb3f0fa5c4d3a9d59d71.svg";